import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";

import { notify } from "../../components/Notification";
import type { ErrorResponse } from "../types";

// `getProfile`'s 401 just means "not signed in"; the ticker endpoints already show inline errors next to
// the fields that caused them, so a toast would duplicate them (the dedup can't catch an inline message).
// The account page shows every failure of its four section reads inline.
const SILENT_ENDPOINTS = new Set([
  "getProfile",
  "discoverListings",
  "createListedInstrument",
  "resolveInstrument",
  "getRequestableExchanges",
  "submitTickerRequest",
  "getPendingTickerRequests",
  "approveTickerRequest",
  "rejectTickerRequest",
  "searchCatalogInstruments",
  "setInstrumentSourceCountry",
  "getHoldings",
  "getHoldingsSummary",
  "getInvestmentHistory",
  "getAccountActivity",
  "getAdminSnapshotQueue",
  "getAdminBackfillQueue",
  "getAdminCoverageImpact",
  "getAdminSchedulers",
  "getAdminTodo",
  "getAdminInstrumentTodos",
  "getAdminInstruments",
  "getAdminInstrument",
  "getAdminJobs",
  "getAdminActivity",
  "retryAdminBackfill",
  "recalculateAdminSnapshot",
  "repairInstrumentListing",
  "recordInstrumentPrice",
  "getAdminCorporateActions",
  "deferCorporateAction",
  "resumeCorporateAction",
  "reconcileCorporateAction",
  "getCashbackSummary",
]);

// Replaces the per-hook `notify.apiError(err)` catch blocks the hand-rolled fetch hooks used. The Notification
// slice dedups by message + type, so this never double-toasts with the interceptor's own notifications.
export const errorToastMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const endpointName = (action.meta as { arg?: { endpointName?: string } })
      ?.arg?.endpointName;
    const isSilent = endpointName ? SILENT_ENDPOINTS.has(endpointName) : false;

    if (!isSilent) {
      notify.apiError(action.payload as ErrorResponse | string);
    }
  }
  return next(action);
};
